


























































import ModalSignInTwoFactorAuth from "@/components/modal/ModalSignInTwoFactorAuth.vue";
import ModalBlockLogin from "@/components/modal/modalLoginFailAttempt/ModalBlockLogin.vue";
import ModalOBPassword from "@/components/modal/modalLoginFailAttempt/ModalOBPassword.vue";
import RecaptchaV2Widget from "@/components/recaptcha/RecaptchaV2Widget.vue";
import { closeV2Challenge, executeV3, loadRecaptchaScript } from "@/helper/recaptchaHelper";
import Liff from "@line/liff";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { LoadingStatusType } from "../../enums/enums";
import TextHelper from "../../helper/textHelper";

const StoreUserInfo = namespace("UserInfo");
const StoreLineToken = namespace("LineToken");
const StoreLoading = namespace("Loading");

const RECAPTCHA_V3_SITE_KEY =
  process.env.VUE_APP_RecaptchaEnterprise_ScoreSiteKey || process.env.VUE_APP_RecaptchaV3_SiteKey || "";

@Component({ components: { ModalSignInTwoFactorAuth, ModalOBPassword, ModalBlockLogin, RecaptchaV2Widget } })
export default class Login extends Vue {
  private email = "";
  private password = "";
  private loginLoading = false;
  private isAlert = false;
  private alertText = "";
  private showModalOBPassword = false;
  private showModalBlockLogin = false;
  private blockLoginLockDurationMinutes = 0;
  private recaptchaV2Token = "";
  private recaptchaBlocked = false;
  @StoreUserInfo.Getter
  private getLogInSuccess!: LoadingStatusType;
  @StoreUserInfo.Action
  private DoLogIn!: (logInData: any) => void;
  @StoreUserInfo.Getter
  private getAlertMessage!: string;
  @StoreUserInfo.Getter
  private getTwoFactorAuthData!: any;
  @StoreUserInfo.Getter
  private getLoginGuardData!: any;
  @StoreUserInfo.Getter
  private getLoginLockedData!: any;
  @StoreUserInfo.Getter
  private getNeedRecaptchaV2!: boolean;
  @StoreUserInfo.Action
  private SetTwoFactorAuthData!: (data: any) => void;
  @StoreLineToken.Action
  private LineTokenAutorize!: (_input: any) => void;
  @StoreLineToken.Getter
  private getLineTokenValidate!: boolean | null;

  @StoreLoading.Action
  private IsLoading!: (loadingStatus: boolean) => void;

  get show2FAModal() {
    const hasData = this.getTwoFactorAuthData !== null;
    return hasData;
  }

  set show2FAModal(value: boolean) {
    if (!value) {
      this.SetTwoFactorAuthData(null);
      this.loginLoading = false;
      this.IsLoading(false);
      this.isAlert = false;
      this.alertText = "";
    }
  }

  get needRecaptchaV2(): boolean {
    return this.getNeedRecaptchaV2;
  }

  get isLoginDisabled(): boolean {
    if (this.loginLoading) return true;
    if (this.recaptchaBlocked) return true;
    if (this.needRecaptchaV2 && !this.recaptchaV2Token) return true;
    return false;
  }

  mounted() {
    if (RECAPTCHA_V3_SITE_KEY) {
      loadRecaptchaScript(RECAPTCHA_V3_SITE_KEY).catch(() => {
        // silent — script load failure should not block login
      });
    }
  }

  beforeCreate() {
    const liffId = process.env.VUE_APP_LineLogInLiffId ?? "";
    Liff.init({ liffId: liffId })
      .then(() => {
        const isLiff = Liff.isInClient() && Liff.isLoggedIn();
        this.DesktopRedirect(isLiff);
        if (isLiff) {
          const token = Liff.getAccessToken();
          this.LineTokenAutorize(token);
        }
      })
      .catch((err) => {
        this.DesktopRedirect(false);
      });
  }
  created() {
    this.IsLoading(true);
  }

  @Watch("getLogInSuccess", {})
  getLogInSuccessChanged() {
    if (this.getLogInSuccess === LoadingStatusType.Success) {
      this.IsLoading(true);
      // Close any open v2 challenge overlay and let grecaptcha finish its async
      // teardown before navigating, so the dialog can't be orphaned on the LIFF
      // webview (where the verify callback fires before the overlay fully closes).
      closeV2Challenge();
      this.$nextTick(() => {
        this.$router.push({ name: "selectList" });
      });
    } else if (this.getLogInSuccess === LoadingStatusType.Loading) {
      this.loginLoading = true;
    } else if (this.getLogInSuccess === LoadingStatusType.Fail) {
      if (this.needRecaptchaV2) {
        this.loginLoading = false;
        this.IsLoading(false);
      } else if (!this.show2FAModal) {
        // ไม่แสดง alert "login_fail" เมื่ออยู่ในโหมด 2FA
        this.HandleLoginFailAttempt();
      }
    } else if (this.getLogInSuccess === LoadingStatusType.None) {
      this.isAlert = false;
    }
  }
  @Watch("getLineTokenValidate", {})
  getLineTokenValidateChanged() {
    if (this.getLineTokenValidate != true) {
      this.IsLoading(false);
    }
  }

  @Watch("needRecaptchaV2")
  onNeedRecaptchaV2Change(newValue: boolean) {
    // single-use token: clear on a new challenge so the button re-disables
    if (newValue) {
      this.recaptchaV2Token = "";
    }
  }

  public DesktopRedirect(isLiff: boolean): void {
    if (!isLiff) {
      this.IsLoading(false);
      this.$router.push({ name: "desktopView" });
    }
  }

  public async Login(recaptchaOverride?: { token: string; version: string }): Promise<void> {
    const logInData: any = {
      email: this.email,
      encpw: TextHelper.CreateToken(this.password),
    };

    if (recaptchaOverride) {
      logInData.recaptchaToken = recaptchaOverride.token;
      logInData.recaptchaVersion = recaptchaOverride.version;
    } else {
      let v3Token = "";
      try {
        v3Token = await executeV3(RECAPTCHA_V3_SITE_KEY, "login");
      } catch {
        // script failed to load/execute — proceed without token
      }
      if (v3Token) {
        logInData.recaptchaToken = v3Token;
        logInData.recaptchaVersion = "v3";
      }
    }

    this.DoLogIn(logInData);
  }

  public onRecaptchaV2Verify(token: string): void {
    this.recaptchaV2Token = token;
    this.recaptchaBlocked = false;
    this.Login({ token, version: "v2" });
  }

  public onRecaptchaV2Expired(): void {
    this.recaptchaV2Token = "";
  }

  public onRecaptchaV2Error(): void {
    this.recaptchaV2Token = "";
    this.recaptchaBlocked = true;
  }

  public FocusInput() {
    this.isAlert = false;
  }

  public HandleLoginFailAttempt() {
    this.isAlert = true;
    this.loginLoading = false;
    this.IsLoading(false);

    if (this.getLoginLockedData) {
      this.HandleLoginLocked(this.getLoginLockedData);
      return;
    }
    if (this.getLoginGuardData) {
      this.HandleLoginGuardFailAttempt(this.getLoginGuardData);
      return;
    }
    this.alertText = this.getAlertMessage || (this.$t("login_fail") as string);
  }

  private FormatLockDuration(totalMinutes: number): string {
    const MINUTES_PER_HOUR = 60;
    if (totalMinutes < MINUTES_PER_HOUR) {
      return this.$t("X_Minutes", { m: totalMinutes }) as string;
    }
    const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
    const minutes = totalMinutes % MINUTES_PER_HOUR;
    if (minutes === 0) return this.$t("X_Hours", { h: hours }) as string;
    return `${this.$t("X_Hours", { h: hours })} ${this.$t("X_Minutes", { m: minutes })}`;
  }

  private ParseLockedUntilAsUtc(lockedUntilStr: string): number {
    const MS_PER_MINUTE = 60000;
    const FALLBACK_MINUTES = 1;
    if (!lockedUntilStr) return FALLBACK_MINUTES;
    const normalized = lockedUntilStr.trim().replace(" ", "T");
    const now = Date.now();
    const asUtcMs = new Date(normalized + "Z").getTime() - now;
    const asLocalMs = new Date(normalized).getTime() - now;
    const remainingMinutes = Math.ceil(Math.max(asUtcMs, asLocalMs) / MS_PER_MINUTE);
    if (isNaN(remainingMinutes) || remainingMinutes <= 0) return FALLBACK_MINUTES;
    return remainingMinutes;
  }

  private HandleLoginLocked(lockedData: { lockedUntil?: string }) {
    const minutes = this.ParseLockedUntilAsUtc(lockedData.lockedUntil || "");
    this.alertText = this.$t("login_locked_try_again_in", {
      duration: this.FormatLockDuration(minutes),
    }) as string;
  }

  private HandleLoginGuardFailAttempt(guardData: any) {
    const STAGE_SHOW_OB_PASSWORD = 1;
    const ATTEMPTS_SHOW_OB_PASSWORD = 3;
    const MIN_ATTEMPTS_SHOW_COUNT = 1;
    const NO_REMAINING_ATTEMPTS = 0;

    const failedAttempts = Number(guardData.failed_attempts) || MIN_ATTEMPTS_SHOW_COUNT;
    const remainingAttempts = Number(guardData.remaining_attempts) || 0;
    const totalAttempts = failedAttempts + remainingAttempts;
    const showAttemptCount = failedAttempts > MIN_ATTEMPTS_SHOW_COUNT || remainingAttempts === NO_REMAINING_ATTEMPTS;

    if (showAttemptCount) {
      this.alertText = this.$t("login_fail_attempt", { x: failedAttempts, y: totalAttempts }) as string;
    } else {
      this.alertText = this.$t("login_fail") as string;
    }

    if (Number(guardData.stage) === STAGE_SHOW_OB_PASSWORD && failedAttempts === ATTEMPTS_SHOW_OB_PASSWORD) {
      this.showModalOBPassword = true;
    }

    if (remainingAttempts === NO_REMAINING_ATTEMPTS) {
      this.blockLoginLockDurationMinutes = Number(guardData.next_lock_duration_minutes) || 0;
      this.showModalBlockLogin = true;
    }
  }
}
